import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { CANCEL_APPOINTMENT_BY_ID } from '../../queries/cancel-appointment-by-id.js';
import { fromCancelAppointmentQueryToAppointment } from './adapters/fromCancelAppointmentQueryToAppointment.js';

function isAppointment(result) {
    return result.__typename === 'Appointment';
}
const useCancelAppointmentById = (token = '')=>{
    const { locale  } = useIntl();
    const [query, queryState] = useMutation(CANCEL_APPOINTMENT_BY_ID, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale,
                Authorization: `Bearer ${token}`
            },
            timeout: 30000
        },
        onError: (error)=>{
            console.error(`Error occurred while executing CANCEL_APPOINTMENT_BY_ID mutation: `, error);
        }
    });
    const data = React.useMemo(()=>{
        var ref, ref1;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.cancelAppointment) && isAppointment((ref1 = queryState.data) === null || ref1 === void 0 ? void 0 : ref1.cancelAppointment) ? fromCancelAppointmentQueryToAppointment(queryState.data.cancelAppointment) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useCancelAppointmentById as default, isAppointment };
//# sourceMappingURL=use-cancel-appointment-by-id.js.map
